import { render, staticRenderFns } from "./AmsThumbnail.vue?vue&type=template&id=87929806&scoped=true&"
import script from "./AmsThumbnail.vue?vue&type=script&lang=js&"
export * from "./AmsThumbnail.vue?vue&type=script&lang=js&"
import style0 from "./AmsThumbnail.vue?vue&type=style&index=0&id=87929806&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87929806",
  null
  
)

export default component.exports